// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import AntD from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';// 引入中文包

import "ant-design-vue/dist/antd.css"
import '../static/css/font-awesome-4.7.0/css/font-awesome.css'

import App from './App'
import router from './router'

import PPStaticMenu from "../static/staticMenu/primitiveLib"  //原始库静态菜单
import CLStaticMenu from "../static/staticMenu/compilingLib"  //整编库静态菜单
import DAStaticMenu from "../static/staticMenu/dataApply"  //数据应用静态菜单



Vue.config.productionTip = false
Vue.prototype.$zhCN = zhCN
//注入静态菜单
Vue.prototype.$PPStaticMenu = PPStaticMenu 
Vue.prototype.$CLStaticMenu = CLStaticMenu  
Vue.prototype.$DAStaticMenu = DAStaticMenu  



Vue.use(AntD)   //注册ant-design-vue,以便Vue程序识别



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template:'<App/>'
})

/*设置页面title*/
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


// WEBPACK FOOTER //
// ./src/main.js